import { useQuery } from "@tanstack/react-query";
import { fetchDepthBuckets, type DepthParams } from "../api/client.ts";

// 5m standing cadence upstream; a 30s poll keeps the card current without
// hammering. Matches useMandateSummary's calmer rhythm.
const POLL_MS = 30_000;

export function useDepthBuckets(p: DepthParams) {
  return useQuery({
    queryKey: ["depth-buckets", p.clientId, p.venue, p.pair, p.bucketSeconds ?? 300],
    queryFn: () => fetchDepthBuckets(p),
    refetchInterval: POLL_MS,
    staleTime: POLL_MS,
  });
}
